import { render, staticRenderFns } from "./t2.vue?vue&type=template&id=7c761089&"
import script from "./t2.vue?vue&type=script&lang=js&"
export * from "./t2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports